import React from "react";

import { Grid } from "@mui/material";
import { Skeleton } from "@mui/material";

import { SkeletonContainer, TrackingDivider } from "./styles";

interface SkeletonTrackingProps {
  isFromMaintenance?: boolean;
}

const SkeletonTracking = ({ isFromMaintenance }: SkeletonTrackingProps) => {
  return (
    <SkeletonContainer isFromMaintenance={isFromMaintenance} container direction="row" spacing={3}>
      <Grid
        container
        item
        direction="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        sm={12}
        md={9}
      >
        <Grid item xs={12}>
          <Skeleton variant="rectangular" width="100%" height={170} />
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="rectangular" width="100%" height={340} />
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="rectangular" width="100%" height={340} />
        </Grid>
        <Grid item xs={12}>
          <Skeleton variant="rectangular" width="100%" height={110} />
        </Grid>
      </Grid>
      <TrackingDivider orientation="vertical" flexItem />
      <Grid container justifyContent="flex-start" alignItems="flex-start" item xs={12} md>
        <Skeleton variant="rectangular" width="100%" height={350} />
      </Grid>
    </SkeletonContainer>
  );
};

export default SkeletonTracking;
